import { useCallback, useEffect, useState } from 'react'
import {
  FilterQuery,
  ProjectFields,
  useAsyncAutocomplete
} from '@yes.technology/react-toolkit'

import fetchYesObjects from 'yesObject/shared/api/fetchYesObjects'
import useFetchSuggestions from '../useFetchSuggestions'

type UseSuggestionsOnChangeProps = {
  objectclassUuid: string
  initialValue?: string
  uuidCurrentSitemodelObjectclass?: string
  skipRelations?: boolean
  skipMetadata?: boolean
  projectFields?: ProjectFields
  interdependentFilteringQuery?: FilterQuery
}

const useSuggestionsOnChange = ({
  objectclassUuid,
  initialValue = '',
  uuidCurrentSitemodelObjectclass = '',
  skipRelations = false,
  skipMetadata = false,
  projectFields,
  interdependentFilteringQuery
}: UseSuggestionsOnChangeProps) => {
  const [value, onChange] = useState(initialValue)

  useEffect(() => {
    onChange(initialValue)
  }, [initialValue])

  const fetchSuggestions = useFetchSuggestions({
    objectclassUuid,
    fetchYesObjects,
    uuidCurrentSitemodelObjectclass,
    skipRelations,
    skipMetadata,
    projectFields,
    interdependentFilteringQuery
  })

  const resetValue = useCallback((value = '') => {
    onChange(value)
  }, [])

  const { isLoading, suggestions } = useAsyncAutocomplete({
    query: value,
    fetchSuggestions
  })

  return {
    value,
    onChange,
    isLoading,
    suggestions,
    resetValue
  }
}

export default useSuggestionsOnChange
